import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "linksContainer", "linkRow", "linkTemplate", "emptyMessage", "destroyField",
    "linkType", "reactFields", "disableFields", "moraleFields", "triggerLabel", "targetLabel",
    "deltaField", "moraleDelta", "messageField", "manualDisableToggle", "manualDisableReason"
  ]

  addLink() {
    if (!this.hasLinkTemplateTarget || !this.hasLinksContainerTarget) return

    const template = this.linkTemplateTarget.innerHTML
    const uniqueId = new Date().getTime()
    const newRow = template.replace(/NEW_RECORD/g, uniqueId)

    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.style.display = "none"
    }

    this.linksContainerTarget.insertAdjacentHTML("beforeend", newRow)
  }

  removeLink(event) {
    const row = event.target.closest("[data-tracker-links-target='linkRow']")
    if (!row) return

    const destroyField = row.querySelector("[data-tracker-links-target='destroyField']")
    if (destroyField && destroyField.name.includes("[id]")) {
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }

    this.syncEmptyMessage()
  }

  linkTypeChanged(event) {
    const row = event.target.closest("[data-tracker-links-target='linkRow']")
    if (!row) return

    this.syncRowType(row, event.target.value)
  }

  syncRowType(row, linkType) {
    const isDisable = linkType === "disable"
    const isMorale = linkType === "morale"
    const isReact = !isDisable && !isMorale

    row.querySelectorAll("[data-tracker-links-target='reactFields']").forEach((el) => {
      el.classList.toggle("d-none", !isReact)
    })
    row.querySelectorAll("[data-tracker-links-target='disableFields']").forEach((el) => {
      el.classList.toggle("d-none", !isDisable)
    })
    row.querySelectorAll("[data-tracker-links-target='moraleFields']").forEach((el) => {
      el.classList.toggle("d-none", !isMorale)
    })

    const triggerLabel = row.querySelector("[data-tracker-links-target='triggerLabel']")
    if (triggerLabel) triggerLabel.textContent = isDisable ? "Value" : "When this crosses"

    const targetLabel = row.querySelector("[data-tracker-links-target='targetLabel']")
    if (targetLabel) {
      if (isDisable) targetLabel.textContent = "Lock tracker"
      else if (isMorale) targetLabel.textContent = "Morale tracker"
      else targetLabel.textContent = "Adjust tracker"
    }

    const deltaField = row.querySelector("[data-tracker-links-target='deltaField']")
    if (deltaField) {
      deltaField.disabled = !isReact
      if (!isReact) deltaField.value = ""
    }

    const moraleDelta = row.querySelector("[data-tracker-links-target='moraleDelta']")
    if (moraleDelta) {
      moraleDelta.disabled = !isMorale
      if (isMorale && !moraleDelta.value) moraleDelta.value = "1"
    }
  }

  syncEmptyMessage() {
    if (!this.hasEmptyMessageTarget) return

    const visible = this.linkRowTargets.some((row) => row.style.display !== "none")
    this.emptyMessageTarget.style.display = visible ? "none" : ""
  }

  manualDisableChanged(event) {
    if (!this.hasManualDisableReasonTarget) return

    this.manualDisableReasonTarget.classList.toggle("d-none", !event.target.checked)
  }
}
